export type DiscountDurationTextKey = 'energyAndMonthlyFee' | 'energy' | 'monthlyFee' | undefined

export const getDiscountDurationText = (props: {
  hasEnergyDiscount: boolean
  hasMonthlyFeeDiscount: boolean
}): DiscountDurationTextKey => {
  const { hasEnergyDiscount, hasMonthlyFeeDiscount } = props

  // if both they have always same duration
  if (hasEnergyDiscount && hasMonthlyFeeDiscount) {
    return 'energyAndMonthlyFee'
  }

  if (hasEnergyDiscount) {
    return 'energy'
  }

  if (hasMonthlyFeeDiscount) {
    return 'monthlyFee'
  }
  return
}
